// extracted by mini-css-extract-plugin
export default {"footer":"Fa","home":"Ga","logo":"Ha","container":"Ia","nav":"Ja","navHeading":"Ka","navList":"La","copyright":"Ma","blinking":"Na"};